@if (startOptions$ | async; as startOptions) {
	<stages-dialog2 #dialog [dialogAriaLabel]="'files.start.title' | translate">
		<stages-dialog-header />
		<div class="content">
			<stages-files-start
				[startOptions]="startOptions"
				headline="files.start.title"
				translateNone="none"
			></stages-files-start>
		</div>
	</stages-dialog2>
}
